import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div 
            className={`flex items-center cursor-pointer transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
            onClick={() => scrollToSection('hero')}
          >
            <span className="text-xl md:text-2xl font-bold text-[#0A1628] hover:text-[#FF6B6B] transition-colors">Webloom</span>
          </div>

          {/* Desktop menu */}
          <div className={`hidden md:flex items-center space-x-8 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <button onClick={() => scrollToSection('services')} className="text-[#0A1628]/70 hover:text-[#0A1628] transition-colors relative group whitespace-nowrap cursor-pointer">
              Services
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF6B6B] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-[#0A1628]/70 hover:text-[#0A1628] transition-colors relative group whitespace-nowrap cursor-pointer">
              Pricing
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FF6B6B] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="bg-[#0A1628] text-white px-6 py-2.5 rounded-full hover:bg-[#FF6B6B] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </div>

          {/* Mobile menu button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#0A1628] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md rounded-2xl shadow-xl p-6 mb-4 space-y-4">
            <button 
              onClick={() => scrollToSection('services')} 
              className="block w-full text-left text-[#0A1628]/70 hover:text-[#0A1628] transition-colors py-3 border-b border-gray-100 cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('pricing')} 
              className="block w-full text-left text-[#0A1628]/70 hover:text-[#0A1628] transition-colors py-3 border-b border-gray-100 cursor-pointer"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="block w-full bg-[#0A1628] text-white px-6 py-3 rounded-full hover:bg-[#FF6B6B] transition-all duration-300 text-center cursor-pointer"
            >
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
